import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import DateRangeField from "components/DateRangeField/DateRangeField";
import { PRESETS } from "../../utils/teamHistoryFilter";
import "assets/styles.css";

const PRESET_OPTIONS = [
  { id: PRESETS.LAST_3_SEASONS, label: "Last 3 Seasons" },
  { id: PRESETS.FULL_HISTORY, label: "Full History" },
  { id: PRESETS.OLYMPIC_CYCLE, label: "Olympic Cycle" },
];

export default function SeasonRangeFilter({
  fromDate,
  toDate,
  minDate,
  maxDate,
  activePreset,
  onPresetChange,
  onFromDateChange,
  onToDateChange,
  disabled,
}) {
  return (
    <Box className="TDHistoricalFilterBox TDSeasonRangeFilterBox">
      <Box className="TDHistoricalFilterPresets">
        <div className="TDHistoricalFilterLabel">Quick Presets</div>
        <Box className="TDHistoricalFilterButtons">
          {PRESET_OPTIONS.map((option) => (
            <button
              key={option.id}
              type="button"
              className={`TDHistoricalPresetButton${
                activePreset === option.id ? " active" : ""
              }`}
              onClick={() => onPresetChange(option.id)}
              disabled={disabled || !minDate}
            >
              {option.label}
            </button>
          ))}
        </Box>
      </Box>
      <Box className="TCControlsRight">
        <DateRangeField
          label="From"
          selected={fromDate}
          onChange={onFromDateChange}
          minDate={minDate}
          maxDate={toDate || maxDate}
          disabled={disabled}
        />
        <DateRangeField
          label="To"
          selected={toDate}
          onChange={onToDateChange}
          minDate={fromDate || minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
}

SeasonRangeFilter.propTypes = {
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  activePreset: PropTypes.string,
  onPresetChange: PropTypes.func.isRequired,
  onFromDateChange: PropTypes.func.isRequired,
  onToDateChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SeasonRangeFilter.defaultProps = {
  fromDate: null,
  toDate: null,
  minDate: null,
  maxDate: null,
  activePreset: null,
  disabled: false,
};
